import { Request } from '@/common/request'

/**
 * 继承请求接口并客制化接口
 */
class DemoApi extends Request {
  constructor () {
    super({})
  }

  /* post请求demo */
  postDemo (data, config) {
    return this.post('/post-demo.do', data, config)
  }

  /* get请求demo */
  getDemo (data, config) {
    return this.get('/get-demo.do', data, config)
  }

  /* mock请求 */
  postMock (data, config) {
    return this.post('/mock-demo.do')
  }

  /* 结果页mock请求 */
  getResult (data, config) {
    return this.get('/resultMock.do')
  }

  /* 发接口 */
  getRecord (url, data, config) {
    return this.get(url, data)
  }

  /**/
  postRecord (url, data, config) {
    return this.get(url, data)
  }
}

export default DemoApi
